import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import * as style from './cookie-banner.module.scss'
import ButtonPrimary from '../../components/common/buttons/ButtonPrimary'

const readCookie = (cookieName) => {
  const name = `${cookieName}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}
const setCookie = (cookieName, cookieValue, cookieDays) => {
  const d = new Date()
  d.setTime(d.getTime() + cookieDays * 24 * 60 * 60 * 1000)
  const expires = `expires=${d.toUTCString()}`
  document.cookie = `${cookieName}=${cookieValue};${expires};path=/`
}

const CookieBanner = () => {
  const [bannerState, setBannerState] = useState(false)

  useEffect(() => {
    if (readCookie('CookiesAccepted')) {
      setBannerState(false)
    } else {
      setBannerState(true)
    }
  }, [])

  const acceptCookies = () => {
    setCookie('CookiesAccepted', true, 365)
    setBannerState(false)
  }
  const rejectCookies = () => {
    setCookie('CookiesAccepted', false, 1)
    setBannerState(false)
  }
  return (
    <>
      {bannerState && (
        <div className={style.cookieBanner}>
          <div className={style.title}>
            <p>
              Visartech Inc. values your privacy. We use cookies to ensure you
              get the best experience on our website.
            </p>
            <p className={style.subtitle}>
              <Link to="/cookie-policy">Learn more</Link>
            </p>
          </div>
          <div
            tabIndex={0}
            role="button"
            onKeyDown={() => acceptCookies()}
            onClick={() => acceptCookies()}
          >
            <ButtonPrimary btnClass={style.button}>
              Accept cookies
            </ButtonPrimary>
          </div>
          <button
            type="button"
            onClick={() => rejectCookies()}
            className={style.btnClose}
          >
            <span className={style.cross} />
            Reject
          </button>
        </div>
      )}
    </>
  )
}

export default CookieBanner
